import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = comprobando, false = no autenticado, obj = autenticado

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // Si volvemos del callback de Google, deja que AuthCallback establezca la sesión.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (email, password, nombre, codigo_invitacion = "") => {
    const { data } = await api.post("/auth/register", { email, password, nombre, codigo_invitacion });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };
  const updateNombre = async (nombre) => {
    const { data } = await api.patch("/auth/me", { nombre });
    setUser(data);
    return data;
  };
  const eliminarCuenta = async (password) => {
    await api.post("/auth/eliminar-cuenta", { password });
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser: check, login, register, logout, updateNombre, eliminarCuenta }}>
      {children}
    </AuthContext.Provider>
  );
}
